import { UserPermissions } from "src/app/services/remote-data-service/dtos/user.dto";
import { BaseEntity } from "../base-entity/base-entity";
import { Roles } from "src/app/services/remote-data-service/repositories/user-repository/user.repository";

/**
 * Class that represents the user of the app.
 *
 */
export class User extends BaseEntity {

  /**
   * Construct a new User object.
   *
   * @param _name
   *   User name.
   */
  constructor(
    _uuid: string,
    protected _name: string,
    protected _status: boolean,
    protected _mail: string,
    protected _roles: Roles[],
    protected _permissions: UserPermissions
  ) {
    super(_uuid)
  }

  get name(): string {
    return this._name;
  }

  get status(): boolean {
    return this._status;
  }

  get mail(): string {
    return this._mail;
  }

  get roles(): Roles[] {
    return this._roles;
  }

  get permissions(): UserPermissions {
    return this._permissions;
  }
}
